module.exports = __webpack_public_path__ + "img/hokenso-internship-2.25c890fc.jpg";